import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider, useAuth } from 'context/AuthContext';
import ProtectedRoute from 'routes/ProtectedRoute';
import allProtectedRoutes from 'routes/index';
import LoginPage from 'pages/LoginPage';
import RegisterPage from 'pages/RegisterPage';
import PublicOnboardingForm from 'pages/PublicOnboardingForm';

// Create Material-UI theme
const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
    background: {
      default: '#f5f5f5',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
});

// Main App Routes
const AppRoutes = () => {
  const { loading } = useAuth();

  // Don't render routes until authentication state is determined
  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/apply" element={<PublicOnboardingForm />} />

      {/* Protected Routes — generated from module route definitions */}
      {allProtectedRoutes.map(({ path, element, role, permission, layout }) => (
        <Route
          key={path}
          path={path}
          element={
            <ProtectedRoute requiredRole={role} requiredPermission={permission} layout={layout}>
              {element}
            </ProtectedRoute>
          }
        />
      ))}

      {/* Default redirects */}
      <Route path="/" element={<Navigate to="/login" replace />} />

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router future={{ v7_relativeSplatPath: true }}>
          <AppRoutes />
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
